import { useState, useCallback, useMemo } from "react";
import { UseFormReturn } from "react-hook-form";
import { GlobalActionKey } from "../domain/globalAction.types";

export function useActionsManager(form: UseFormReturn<any>, actionsFieldName: string) {
  const [modalOpen, setModalOpen] = useState(false);
  const [editingKey, setEditingKey] = useState<string | null>(null);

  const watchedActions = form.watch(actionsFieldName);
  const actions = useMemo(() => (watchedActions || {}) as Record<string, string>, [watchedActions]);

  const handleOpenAdd = useCallback(() => {
    setEditingKey(null);
    setModalOpen(true);
  }, []);

  const handleEdit = useCallback((key: string) => {
    setEditingKey(key);
    setModalOpen(true);
  }, []);

  const handleDelete = useCallback(
    (key: string) => {
      const { [key]: _, ...newActions } = actions;
      form.setValue(actionsFieldName, newActions);
    },
    [actions, form, actionsFieldName]
  );

  const handleSave = useCallback(
    (key: GlobalActionKey, value: string) => {
      const newActions = { ...actions, [key]: value };
      form.setValue(actionsFieldName, newActions);
      setModalOpen(false);
      setEditingKey(null);
    },
    [actions, form, actionsFieldName]
  );

  const handleClose = useCallback(() => {
    setModalOpen(false);
    setEditingKey(null);
  }, []);

  const existingKeys = Object.keys(actions);
  const editingValue = editingKey !== null ? actions[editingKey] : undefined;

  return {
    actions,
    modalOpen,
    editingKey,
    editingValue,
    existingKeys,
    handleOpenAdd,
    handleEdit,
    handleDelete,
    handleSave,
    handleClose,
  };
}
